// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import App from './App';
import router from './router';

OfflinePluginRuntime.install();


Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'production') {
  Raven
    .config('https://fa045c6589af499f86db6e761ac36491@sentry.io/187474', {
      release: COMMITHASH, //eslint-disable-line
    })
    .addPlugin(RavenVue, Vue)
    .install();
}

router.afterEach((to, from) => {//eslint-disable-line
  ga('set', 'page', to.path);//eslint-disable-line
  ga('send', 'pageview'); //eslint-disable-line
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  router,
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js